import React from 'react';
import {useControllerProps} from '../../../../../domain/controllers/ControllerContext';
import {classes} from './PriceBreakdown.st.css';
import {Divider} from 'wix-ui-tpa/cssVars';
import {CouponTotal} from '../../../../../common/components/CouponTotal/CouponTotal';
import {PriceBreakdownSkeleton} from './Skeleton/Skeleton';
import {TotalAmount} from './TotalAmount/TotalAmount';

export enum PriceBreakdownDataHooks {
  priceBreakdownDivider = 'PriceBreakdown.priceBreakdownDivider',
  priceBreakdownContainer = 'PriceBreakdown.priceBreakdownContainer',
  priceBreakdownSkeleton = 'PriceBreakdown.priceBreakdownSkeleton',
}

export const PriceBreakdown = () => {
  const {
    cartModel,
    cartSummary: estimatedTotals,
    isSummaryUpdating,
    refactorCouponOnCart,
  } = useControllerProps().cartStore;

  const appliedCoupon = refactorCouponOnCart ? cartModel.coupon : estimatedTotals?.appliedCoupon || cartModel.coupon;
  const isCouponApplied = !!appliedCoupon;
  const totalAmount =
    estimatedTotals?.priceSummary.subtotal.formattedConvertedAmount ?? cartModel.subtotal?.formattedConvertedAmount;

  return (
    <div>
      {isCouponApplied && (
        <>
          <Divider className={classes.divider} data-hook={PriceBreakdownDataHooks.priceBreakdownDivider} />
          <div className={classes.container} data-hook={PriceBreakdownDataHooks.priceBreakdownContainer}>
            {isSummaryUpdating ? (
              <PriceBreakdownSkeleton />
            ) : (
              <>
                <TotalAmount totalAmount={totalAmount} />
                <CouponTotal shouldShowDivider={false} />
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
};
